import { useState, useEffect, useContext, useMemo } from "react";
import { useParams, useHistory} from "react-router-dom";
import { useAlert } from "react-alert";
import { useMediaQuery } from "react-responsive";

import "./Assesment.css";
import "./PracticeAssesment.css";

import AssesmentHeader from "./AssesmentHeader";
import PracticeStatsBar from "./Stats";
import ProgressBar from "./ProgressBar";
import Popup from "./Popup";
import useSlider from "./useSlider";
import { GlobalContext } from "../../../context/GlobalState";
import Drawer from "../../Navbar/Drawer";
import Save from "../../../images/assessment/Icon.png";
import { msToTime } from "../../../shared/utils/time";
import { Breadcrumb } from "../../../shared/ui/Breadcrumb";

const getPercentage = (a, b) => {
  a = parseInt(a);
  b = parseInt(b);


  if (b == 0) {
    return 0;
  } else {
    return Number.parseInt((a * 100) / b);
  }
};

const getTotal = (object) => {
  if (!object) {
    return 0;
  }

  return object.easy + object.intermediate + (object.difficult || object.hard);
};

const Assesment = () => {
  //Create instances
  const params = useParams();
  const history = useHistory();
  const { userDetails } = useContext(GlobalContext);
  const alert = useAlert();
  const isSmall = useMediaQuery({ query: "(max-width: 472px)" });

  //Extracting data
  const studentId = userDetails.userId;
  const sectionId = window.localStorage.getItem("sectionId");
  const subjectId = params.subjectId;
  const subjectName = params.subjectName;
  const chapterId = params.chapterId;
  const chapterName = params.chapterName;
  const {topicId,topicName,category} = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    return {
      topicId:searchParams.get("topicId") || params.topicId,
      topicName:searchParams.get("topicName") || params.topic,
      category:searchParams.get("category")
    }
  },[]);

  //state and fucntion for practice sessions
  const [practiceSession, setPracticeSession] = useState({});
  const [totalAttemptedQuestions, setAttemptedQuestions] = useState(0);
  const [totalQuestionsToAttempt, setTotalQuestionsToAttempt] = useState(1);
  const [correctlyAnswered, setCorrectlyAnswered] = useState(0);
  const [progress, setProgress] = useState(0);
  const [sessionCompleted, setSessionCompleted] = useState(false);
  const [awardedGrade, setAwardGrade] = useState("");
  const [startingTime, setStartingTime] = useState(new Date().getTime());
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [noQuestionsCreated, setNoQuestionsCreated] = useState(false);
  const [loading, setLoading] = useState(false);

  const resetPracticeSession = async () => {
    try {
      await fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/students/${studentId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/practiceSession/${practiceSession._id}/reset`,
        {
          method: "DELETE",
          headers: {
            token: `${window.localStorage.getItem("authToken")}`,
          },
        },
      );
      window.location.reload();
    } catch (error) {
      alert.error(error.message);
      console.log(error);
    }
  };

  const fetchPracticeSession = async () => {
    setLoading(true);
    try {
      await fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/students/${studentId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/practiceSession?topicId=${topicId}&category=${category}`,
        {
          headers: {
            token: `${window.localStorage.getItem("authToken")}`,
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(
            "Session creation response for Practice Session ====> ",
            response,
          );

          //If success then move to the practice session component
          if (response.status === "success") {
            if (response.data.practiceSession.totalQuestionsToAttempt === 0) {
              setNoQuestionsCreated(true);
            }
            setPracticeSession(response.data.practiceSession);
            setAttemptedQuestions(
              getTotal(response.data.practiceSession.totalQuestionsAttempted),
            );
            setTotalQuestionsToAttempt(
              getTotal(response.data.practiceSession.totalQuestionsToAttempt),
            );
            setCorrectlyAnswered(
              getTotal(response.data.practiceSession.correct),
            );
            setProgress(
              getPercentage(
                response.data.practiceSession.questions.length,
                getTotal(response.data.practiceSession.totalQuestionsToAttempt),
              ),
            );
            setQuestionCount(questionCount + 1);
          } else {
            alert.error(response.message);
            console.log(response);
          }
        });
    } catch (error) {
      alert.error(error.message);
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPracticeSession();
  }, []);

  //State and variables for modal and slider
  const [modal, setModal] = useState(false);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);
  const [handleSlide, showSlide] = useSlider();

  //Satte and variables for questions
  const [question, setQuestion] = useState({});
  const [questionCount, setQuestionCount] = useState(0);

  //Function to fetch question
  const fetchQuestion = async () => {
    if (!practiceSession._id) {
      return;
    }
    setLoading(true);
    await fetch(
      `${process.env.REACT_APP_ORIGIN}/api/v1/students/${studentId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/practiceSession/${practiceSession._id}/questions`,
      {
        headers: {
          token: `${window.localStorage.getItem("authToken")}`,
        },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.status === "success") {
          if (response.sessionStatus === "completed") {
            setSessionCompleted(true);
            return;
          }

          setQuestion(response.data.question);
          setStartingTime(new Date().getTime());
        } else {
          alert.error(response.message);
        }
      });
    setButtonDisabled(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchQuestion();
  }, [questionCount]);

  //to check whether the student has started an already-completed session
  useEffect(() => {
    if (totalAttemptedQuestions === totalQuestionsToAttempt) {
      if (totalQuestionsToAttempt === 0) {
        setNoQuestionsCreated(true);
      }
      setSessionCompleted(true);
    } else {
      setSessionCompleted(false);
    }
  }, [practiceSession]);

  //To render the modal once the student completes the session
  useEffect(() => {
    if (sessionCompleted) {
      setStatus("completed");
      setMessage(
        totalQuestionsToAttempt === 0
          ? "Questions are not created yet"
          : "No more questions left to attempt",
      );
      setModal(true);
    }
  }, [sessionCompleted]);

  //States for answers
  const [correctAnswer, setCorrectAnswer] = useState();
  const [allAttemptsWrong, setAllAttemptsWrong] = useState(false);

  //Function to submit correct answer
  const submitAnswer = async () => {
    //Check if the studnt clicks the button to move to next question
    if (allAttemptsWrong) {
      setAllAttemptsWrong(false);
      setQuestionCount(questionCount + 1);
      setModal(false);
      return;
    }

    //Disable the button
    setButtonDisabled(true);
    setLoading(true);

    //body to be sent in response
    const body = {
      answer: correctAnswer,
      questionId: question._id,
      timeTaken: new Date().getTime() - startingTime,
    };

    await fetch(
      `${process.env.REACT_APP_ORIGIN}/api/v1/students/${studentId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/practiceSession/${practiceSession._id}/questions`,
      {
        method: "POST",
        headers: {
          token: `${window.localStorage.getItem("authToken")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("Submit answer response ===> ", response);

        setAllAttemptsWrong(false);
        if (response.status === "success") {
          //Update stats of practice session
          setAttemptedQuestions(
            getTotal(response.data.practiceSession.totalQuestionsAttempted),
          );

          setCorrectlyAnswered(getTotal(response.data.practiceSession.correct));
          
          setProgress(
            getPercentage(
              response.data.practiceSession.questions.length,
              getTotal(response.data.practiceSession.totalQuestionsToAttempt)
            ),
          );

          if (response.sessionStatus === "completed") {
            setSessionCompleted(true);
            return;
          }

          //If the answer is correct, move to next question
          if (response.data.correct) {
            // alert.success("Correct")
            setStatus("correct");
            setMessage(null);
            setQuestionCount(questionCount + 1);
            setButtonDisabled(false);
          }
          //Check if tthere s an attempt left
          else if (!response.data.correct && response.data.attemptLeft === 1) {
            // alert.error("Wrong Answer")
            setStatus("incorrect");
            setMessage(null);
            // if(question.questionType==="mmcq"){
            //   setCorrectAnswer([])
            // }else{
            //   setCorrectAnswer({})
            // }
            setButtonDisabled(false);
          }
          //If wrong, then give another chance
          else if (!response.data.correct && !response.data.attemptLeft) {
            setStatus("incorrect");
            // alert.error("Wrong Answer")
            setMessage("Correct answer is: " + response.data.correctAnswers);
            setAllAttemptsWrong(true);
            setButtonDisabled(false);
          }
        } else {
          setStatus("error");

          //Handle the incoming of any abnormal behaviour such that the Submit button autmatically turns to Next
          if (
            response.message.includes("wrong") ||
            response.message.includes("already")
          ) {
            setAllAttemptsWrong(true);
          }
          setMessage(response.message);
          // alert.error(response.message)
          setButtonDisabled(false);
        }
        setModal(true);
      });

    setButtonDisabled(false);
    setLoading(false);
  };

  const exit = async () => {
    await fetch(
      `${process.env.REACT_APP_ORIGIN}/api/v1/students/${studentId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/practiceSession/${practiceSession._id}/exit`,
      {
        headers: {
          token: `${window.localStorage.getItem("authToken")}`,
        },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("Response ===> ", response);

        if (response.status === "success") {
          history.push("/myassessment");
        } else {
          alert.error(response.message);
        }
      });
    setButtonDisabled(false);
  };

  const confirm = () => {
    setModal(!modal);
    //Move to next question
    if (status === "incorrect" && allAttemptsWrong) {
      submitAnswer();
    }
  };

  return (
    <>
      <Popup
        modal={modal}
        setModal={setModal}
        status={status}
        message={message}
        attemptsLeft={allAttemptsWrong}
        confirm={confirm}
        reset={resetPracticeSession}
        noQuestionsCreated={totalQuestionsToAttempt === 0}
      />
      <section className="mb-4">
        <div className="container">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className="mainCont">
              {isSmall ? (
                <Breadcrumb
                  className="mb-4"
                  items={[
                    { label: "Practice Assessment" },
                    { label: subjectName },
                    { label: chapterName },
                    topicName ? { label: topicName } : null,
                  ]}
                />
              ) : (
                <AssesmentHeader
                  title={"Practice Assessment"}
                  totalAttemptedQuestions={totalAttemptedQuestions}
                  totalQuestionsToAttempt={totalQuestionsToAttempt}
                  correctlyAnswered={correctlyAnswered}
                  awardedGrade={awardedGrade}
                  timeSpend={practiceSession.timeSpend}
                  sessionCompleted={sessionCompleted}
                  progress={progress}
                />
              )}
              {/*<ProgressBar
                width={progress}
                createdAt={practiceSession.createdAt}
              />*/}
              <PracticeStatsBar
                total={totalQuestionsToAttempt}
                attempted={totalAttemptedQuestions}
                correct={correctlyAnswered}
                incorrect={totalAttemptedQuestions - correctlyAnswered}
                timeSpend={practiceSession.timeSpend}
                progress={progress}
                createdAt={practiceSession.createdAt}
              />
            </div>
          </div>
          {!sessionCompleted
            ? showSlide(
                question,
                questionCount,
                correctAnswer,
                setCorrectAnswer,
                loading,
              )
            : ""}
          <br />
          <br />
          <br />
          <br />
          {!sessionCompleted ? (
            <div className="practice-assessment-buttons">
              <button
                className="save-btn"
                onClick={() => {
                  setModal((state) => !state);
                  exit();
                }}
              >
                <img src={Save} alt="save-btn" />
                Save and Exit
              </button>

              <button
                className={
                  buttonDisabled ? "save-btn disabled_button" : "save-btn"
                }
                onClick={() => {
                  submitAnswer();
                }}
                disabled={buttonDisabled}
              >
                <img src={Save} alt="save-btn" />
                {allAttemptsWrong
                  ? "Next"
                  : buttonDisabled
                  ? "Submitting"
                  : "Submit"}
              </button>
              {/* <LeftArrow className='slider-img' onClick={submitAnswer} /> */}
              {/* <img
              src={RightArrow}
              alt='right-arrow'
              className='slider-img'
              onClick={(e) => handleSlide(e)}
            /> */}
            </div>
          ) : (
            <></>
          )}
        </div>
      </section>
    </>
  );
};

export default Assesment;
